<template>
    <div>
        <header id="header">
            <div class="header-container">
                <div class="header-banner">
                    <div class="container">
                        <div class="inner"></div>
                    </div>
                </div>
                <nav class="header-nav">
                    <div class="bottomnav">
                        <div class="container">
                            <div class="inner">
                                <div class="row ApRow" style>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-8 col-sp-8 logo-w ApColumn">
                                        <div class="header_logo">
                                            <RouterLink to="/" @click.prevent="gotoIndexPage()">
                                                <img class="logo img-responsive"
                                                    src="/logo/purple.png"
                                                    alt="Leo Stationero" 
                                                    loading="lazy"
                                                    style="height: 50px;"
                                                />
                                            </RouterLink>
                                        </div>
                                    </div>
                                    <div
                                        class="col-xl-6 col-lg-6 col-md-6 col-sm-8 col-xs-12 col-sp-12 search-w ApColumn">
                                        <SearchBar />
                                    </div>
                                    <CartSection />
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
                <div class="header-top">
                    <div class="container">
                        <div class="inner">
                            <div class="row ApRow" style>
                                <div class="col-xl-3 col-lg-4 col-md-10 col-sm-10 col-xs-10 col-sp-10 ApColumn">
                                    <div id="memgamenu-form_3386463102882933" class="ApMegamenu" v-click-outside="onOutsideClick">
                                        <div data-megamenu-id="3386463102882933" class="leo-verticalmenu"
                                            :class="{ 'active': activeCategories }"
                                            @click.prevent="activeCategories = !activeCategories">
                                            <h4 class="title_block verticalmenu-button">
                                                Browse Categories
                                            </h4>
                                            <div class="box-content block_content">
                                                <div class="verticalmenu" role="navigation">
                                                    <ul class="nav navbar-nav megamenu vertical right">
                                                        <li data-menu-type="category" class="nav-item"
                                                            v-for="(cate, i) in categories" :key="i"
                                                            @click.prevent="gotoResultPage(cate)">
                                                            <a class="nav-link has-category" href="javascript:void(0)"
                                                                target="_self">
                                                                <span class="hasicon menu-icon-class">
                                                                    <!-- <i class="fal fa-archive"></i> -->
                                                                    <img v-if="cate?.image?.length" class="logo img-responsive"
                                                                        style="width: 28px; height: 18px;"
                                                                        :src="cate.image" :alt="cate.slug"
                                                                        loading="lazy" />
                                                                    <span class="menu-title">{{ cate.name }}
                                                                    </span>
                                                                </span>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-12 col-md-8 col-xl-6 ApColumn hoz-menu">
                                    <div id="memgamenu-form_2086913398243511" class="ApMegamenu">
                                        <nav class="leo-megamenu navbar navbar-expand-md navbar-light enable-canvas"
                                            role="navigation" data-megamenu-id="2086913398243511">
                                            <button class="navbar-toggler" type="button"
                                                @click.prevent="activeMobleNav = !activeMobleNav"
                                                aria-label="Toggle navigation">
                                                <span class="navbar-toggler-icon">&#9776;</span>
                                            </button>

                                            <div :class="[
                                                'collapse navbar-collapse megamenu-off-canvas megamenu-off-canvas-2086913398243511',
                                                { 'collapse': activeMobleNav }
                                            ]">
                                                <ul class="navbar-nav w-100 justify-content-start">
                                                    <li class="nav-item">
                                                        <RouterLink class="nav-link" to="/">Home</RouterLink>
                                                    </li>
                                                    <li class="nav-item">
                                                        <RouterLink class="nav-link" to="/products">Products
                                                        </RouterLink>
                                                    </li>
                                                    <li class="nav-item">
                                                        <a class="nav-link"
                                                            href="https://demo74.leotheme.com/prestashop/leo_stationero_demo/en/contact-us"
                                                            target="_self">
                                                            Contact
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </nav>
                                    </div>
                                </div> -->
                                <!-- <CommonsNavMegaMenu /> -->
                                <!-- v-if="activeMobleNav -->
                                <div class="col-xl-6 col-lg-8 col-md-2 col-sm-2 col-xs-2 col-sp-2 hoz-menu ApColumn">
                                    <div id="memgamenu-form_2086913398243511" class="ApMegamenu">
                                        <nav data-megamenu-id="2086913398243511"
                                            class="leo-megamenu cavas_menu navbar navbar-default enable-canvas"
                                            role="navigation">
                                            <div class="navbar-header">
                                                <button type="button" class="navbar-toggler hidden-lg-up"
                                                    data-toggle="collapse"
                                                    data-target=".megamenu-off-canvas-2086913398243511"
                                                    @click.prevent="toggleMobileMenu">
                                                    <span class="sr-only">Toggle
                                                        navigation</span>
                                                    &#9776;
                                                </button>
                                            </div>

                                            <!-- :class="{ 'collapse': !activeMobleNav, 'navbar-collapse': true }" -->
                                            <div
                                                class="collapse leo-top-menu navbar-toggleable-md megamenu-off-canvas megamenu-off-canvas-2086913398243511">
                                                <ul class="nav navbar-nav megamenu horizontal">
                                                    <li data-menu-type="url" class="nav-item">
                                                        <RouterLink class="nav-link has-category" to="/">Home
                                                        </RouterLink>
                                                    </li>
                                                    <li data-menu-type="url" class="nav-item">
                                                        <RouterLink class="nav-link has-category" to="/products">Products
                                                        </RouterLink>
                                                    </li>
                                                    <li data-menu-type="url" class="nav-item">
                                                        <RouterLink class="nav-link has-category" to="/contact">Contact
                                                        </RouterLink>
                                                    </li>
                                                </ul>
                                            </div>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <teleport to="body">
                <div class="megamenu-overlay" data-megamenu-id="2086913398243511"></div>
                <CommonsNavMegaMenu v-if="activeMobleNav" @close="toggleMobileMenu"/>
            </teleport>
        </header>
    </div>
</template>

<script setup>
import SearchBar from './component/SearchBar.vue';
import CartSection from './component/CartSection.vue';
import { useCommonStore } from "@/stores/common.store";
const commonStore = useCommonStore();

const activeCategories = ref(false);
const activeMobleNav = ref(false);

const router = useRouter();
const categories = computed(() => commonStore.categories ?? []);
const gotoIndexPage = async () => {
    router.push({
        name: "index",
    })
}
const gotoResultPage = (val) => {
    if (val?.name?.length){
        // let cateName = val?.name?.length ? val.name : "";
        let cateId = val?.id ? val.id : "";
        let queryVal = {
            category: cateId
        };
        // if (cateId.length) queryVal.categoryId = cateId;
        
        router.push({
            name: "products",
            query: queryVal,
        });
    }
}

const fetchCategories = async () => {
    await commonStore.fetchCategories();
};

const toggleMobileMenu = () => {
  document.body.classList.toggle('off-canvas-active');
  activeMobleNav.value = !activeMobleNav.value;
}
const onOutsideClick = () => {
    activeCategories.value = false;
};

onMounted(() => {
  fetchCategories();  
})
</script>

<style></style>
